import { Button, Grid } from "@aws-amplify/ui-react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import LocalizedStrings from "react-localization";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

import ItemListCollection from "../ItemListCollection";
import { listUsers } from "graphql/queries";

export const UsersChoose = ({
  initUsersGranted = [],
  onChangeUsersGranted,
  resetValues
}) => {
  const [usersAvailable, setUsersAvailable] = useState([]);
  const [usersGranted, setUsersGranted] = useState([]);
  const [usersAvailableSelected, setUsersAvailableSelected] = useState([]);
  const [usersGrantedSelected, setUsersGrantedSelected] = useState([]);
  const [keywordUsersGranted, setKeywordUsersGranted] = useState("");

  async function fetchUsersAvailable(keyword, diffUsers) {
    try {
      const usersData = await API.graphql(
        graphqlOperation(listUsers, {
          limit: !keyword ? 20 : undefined,
          filter: keyword
            ? {
                or: [
                  {
                    email: { contains: keyword },
                  },
                ],
              }
            : {},
        })
      );
      const usersItems = usersData.data.listUsers.items;
      setUsersAvailable(
        usersItems
          ?.filter(
            (userItem) =>
              !diffUsers?.some((diffUs) => diffUs.id === userItem.id)
          )
          ?.map((userItem) => ({
            id: userItem.id,
            name: userItem.email,
          }))
      );
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    setUsersGranted(initUsersGranted);
    fetchUsersAvailable(undefined, initUsersGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initUsersGranted, resetValues]);

  useEffect(() => {
    if (onChangeUsersGranted) onChangeUsersGranted(usersGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersGranted]);

  const cleanSelected = () => {
    setUsersAvailableSelected([]);
    setUsersGrantedSelected([]);
  };

  const setInAvailable = (items) => {
    setUsersAvailable((prevSt) => [...prevSt, ...items]);
    setUsersGranted((prevSt) =>
      prevSt.filter((prev) => !items?.some((user) => user.id === prev.id))
    );
    cleanSelected();
  };

  const setInGranted = (items) => {
    setUsersGranted((prevSt) => [...prevSt, ...items]);
    setUsersAvailable((prevSt) =>
      prevSt.filter((prev) => !items?.some((user) => user.id === prev.id))
    );
    cleanSelected();
  };

  const onSearchUsersGranted = (keyword) => {
    setKeywordUsersGranted(keyword);
  };

  return (
    <Grid templateColumns={{ base: "1fr", large: "2fr 1fr 2fr" }} gap="30px">
      <div>
        <div className="fs-5 mb-3">{strings.users.available}</div>
        <ItemListCollection
          items={usersAvailable}
          selectedItems={usersAvailableSelected}
          setSelectedItems={setUsersAvailableSelected}
          onSearchSubmit={(keyword) =>
            fetchUsersAvailable(keyword, usersGranted)
          }
          orderBy="ASC"
        />
      </div>
      <div style={styles.containerButtons}>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(usersGrantedSelected)}
        >
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(usersGranted)}
        >
          <IoIosArrowBack />
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(usersAvailableSelected)}
        >
          <IoIosArrowForward />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(usersAvailable)}
        >
          <IoIosArrowForward />
          <IoIosArrowForward />
        </Button>
      </div>
      <div>
        <div className="fs-5 mb-3">{strings.users.granted}</div>
        <ItemListCollection
          items={
            keywordUsersGranted
              ? usersGranted.filter((userGr) =>
                  userGr.name
                    .toLowerCase()
                    .includes(keywordUsersGranted?.toLowerCase())
                )
              : usersGranted
          }
          selectedItems={usersGrantedSelected}
          setSelectedItems={setUsersGrantedSelected}
          onSearchSubmit={onSearchUsersGranted}
          orderBy="ASC"
        />
      </div>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    users: {
      available: "Usuarios disponibles",
      granted: "Usuarios otorgados",
    },
    responses: {
      errorFetch: "Error al consultar usuarios",
    },
  },
});

const styles = {
  containerButtons: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    gap: "10px",
  },
  buttonActions: {
    width: "65px",
    alignSelf: "center",
  },
};

export default UsersChoose;
